module.exports = __webpack_public_path__ + "img/step03.9c31a9c4.png";